var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArmchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 9V6a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 16a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 18v2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18v2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmchair);
export default __webpack_public_path__ + "static/media/armchair.dd932e36e6baa712828dcae4eb5e531c.svg";
export { ForwardRef as ReactComponent };